module.exports = __webpack_public_path__ + "img/Character_Thoma_Thumb.7cfee7d3.png";